import Fluxxor from 'fluxxor';
import { NodeStyleEventEmitter } from 'rxjs/observable/FromEventObservable';
import { WlWindow } from 'typings/globals/cordova';

import actions, {
  ExperienceFilterActionsInterface,
  FiltersActionsInterface,
} from './actions/actions';
import dispatcher from './actions/dispatcher';
import { FilterStoreInterface } from './stores/FiltersStore';
import stores from './stores/stores';

declare const window: WlWindow;

export interface FluxStore extends NodeStyleEventEmitter {
  on: any;
}

export interface FluxType {
  stores: {
    ExperienceStore: any;
    ExperienceFilterStore: any;
    FiltersStore: FilterStoreInterface;
    LocationsStore: any;
    TranslationStore: any;
    OfferRequestStore: any;
    SearchStore: any;
  };
  actions: {
    filters: FiltersActionsInterface;
    experiencefilter: ExperienceFilterActionsInterface;
    [index: string]: any;
  };
  store: <T extends FluxStore>(name: string) => T;
}

export interface Loading<T> {
  loading: boolean;
  offline?: boolean;
  cached?: boolean;
  data: T;
}

export function buildFlux(): FluxType {
  const flux = new Fluxxor.Flux(stores.stores, {});

  if (DEBUG) {
    // needed for react chrome dev tools
    window.flux = flux;
  }

  actions(flux);
  flux.on('dispatch', dispatcher());

  setTimeout(() => flux.actions.locations.fetchApprovedLocations());

  return flux;
}
